export default function checkDecimalAllZero(str: string) {
  return str
    .split('.')[1]
    .split('')
    .every((char) => char === '0');
}
